import { createActionCreator } from '../utils/helpers';

import { requestHelp, requestHelpUpdate } from './types';

export const requestRequestHelp = createActionCreator(requestHelp.request, 'fundingSearchId');
export const requestRequestHelpSuccess = createActionCreator(requestHelp.success, 'response');
export const requestRequestHelpFailure = createActionCreator(requestHelp.failure, 'error');

export const requestRequestHelpUpdate = createActionCreator(
  requestHelpUpdate.request,
  'fundingSearchId',
  'payload',
  'promise',
);
export const requestRequestHelpUpdateSuccess = createActionCreator(requestHelpUpdate.success);
export const requestRequestHelpUpdateFailure = createActionCreator(
  requestHelpUpdate.failure,
  'error',
);
